function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.15513 13.5257C7.35507 13.7162 7.6716 13.7084 7.86207 13.5085C8.05253 13.3086 8.0448 12.992 7.84487 12.8016L3.67733 8.8319L13.5 8.8319C13.7761 8.8319 14 8.6081 14 8.3319C14 8.05576 13.7761 7.8319 13.5 7.8319L3.67707 7.8319L7.84487 3.86204C8.0448 3.67158 8.05253 3.3551 7.86207 3.15514C7.6716 2.9552 7.35507 2.9475 7.15513 3.13796L2.2092 7.8491C2.09647 7.95643 2.02987 8.09336 2.00927 8.23576C2.0032 8.2669 2 8.29903 2 8.3319C2 8.36503 2.0032 8.39743 2.0094 8.42876C2.03013 8.57083 2.09673 8.70743 2.2092 8.81456L7.15513 13.5257Z",
  fill: "white"
});

var SvgNavArrLeft = function SvgNavArrLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNavArrLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nav_arr_left.7bd802fd.svg";
export { ForwardRef as ReactComponent };